import { StyledDivider } from "baseui/divider"
import { RelatedPlants } from "../BaseCounter/RealtedPlants"
import InsightsPanel from "./InsightsPanel"
import { useStyletron } from "baseui"


export const SideviewPanel = (props: any) => {
    const [css,] = useStyletron();
    return (
        <>
            <InsightsPanel {...props}></InsightsPanel>
            <StyledDivider className={css({ width: '100%'})}></StyledDivider>
            <RelatedPlants {...props}></RelatedPlants>
        </>
    )
}